module.exports = __webpack_public_path__ + "static/daniel_diaz-801c790f588fad0b9b09846dfa4a373f.jpg";